import { useState } from "react";
import axios from "axios";
import { Loader2, Inbox } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [passcode, setPasscode] = useState("");
  const [messages, setMessages] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API}/admin/messages`, {
        headers: { "X-Admin-Passcode": passcode },
      });
      setMessages(res.data);
    } catch (err) {
      setError("Falscher Code oder Serverfehler.");
      setMessages(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-page" className="min-h-screen bg-[#050505] text-zinc-100 px-6 py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-display text-4xl tracking-tight mb-2">Nachrichten</h1>
        <p className="text-sm text-zinc-500 mb-10">Kontaktanfragen von der Website — nur für Clive.</p>

        <form data-testid="admin-passcode-form" onSubmit={load} className="flex gap-4 mb-12">
          <input
            data-testid="admin-passcode-input"
            type="password"
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            placeholder="Admin-Code"
            className="flex-1 bg-transparent border border-white/15 px-4 py-3 text-sm focus:outline-none focus:border-white/60 transition-[border-color] duration-300"
          />
          <button
            data-testid="admin-load-button"
            type="submit"
            disabled={loading}
            className="px-8 py-3 bg-white text-black text-xs uppercase tracking-[0.25em] hover:bg-zinc-300 transition-[background-color] duration-300 disabled:opacity-50 flex items-center gap-2"
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            Laden
          </button>
        </form>

        {error && (
          <p data-testid="admin-error" className="text-sm text-red-400 border border-red-400/30 px-4 py-3 mb-8">
            {error}
          </p>
        )}

        {messages && messages.length === 0 && (
          <div data-testid="admin-empty" className="flex flex-col items-center gap-3 text-zinc-500 py-20 border border-white/10">
            <Inbox size={28} />
            <p className="text-sm">Noch keine Nachrichten.</p>
          </div>
        )}

        <div className="space-y-6">
          {messages?.map((m) => (
            <article key={m.id} data-testid={`admin-message-${m.id}`} className="border border-white/10 p-6">
              <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
                <h2 className="font-display text-xl tracking-tight">{m.name}</h2>
                <time className="text-xs text-zinc-500">
                  {new Date(m.created_at).toLocaleString("de-CH")}
                </time>
              </div>
              <a href={`mailto:${m.email}`} className="text-sm text-zinc-400 hover:text-white transition-colors duration-300">
                {m.email}
              </a>
              {m.subject && (
                <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-2">{m.subject}</p>
              )}
              <p className="mt-4 text-sm text-zinc-300 leading-relaxed whitespace-pre-wrap">{m.message}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
